import { ConsentManager } from '@vgtv/consent-manager';

import type { Category } from '@vgtv/consent-manager';

const allowlist: Category[] = [
  'CMP:advertising',
  'CMP:personalisation',
  'CMP:analytics',
  'CMP:marketing',
] as const;

export const consentManager = new ConsentManager({ allowlist });
